<template>
  <h1>Privacy Policy</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>